import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { UserInputDialogComponent } from '../edit-user-input/dialog-user-input.component';
import { RouseConfigService } from '../../rouse.config.service';

@Component({
  selector: 'app-edit-user-input',
  templateUrl: './edit-user-input.component.html',
  styleUrls: ['./edit-user-input.component.css']
})
export class EditUserInputComponent implements OnInit {

  userInputs: any[] = [];
  dirty: boolean = false;

  constructor(private rouseService: RouseConfigService, public dialog: MatDialog) {
    this.initialize();
  }

  ngOnInit() {
    this.initialize();
  }

  async initialize(): Promise<void> {
    this.userInputs = await this.rouseService.getUserInputs();
  }

  addUserInput() {
    const dialogRef = this.dialog.open(UserInputDialogComponent, {
      width: '550px',
      data: {
        dialogTitle: 'Add new user input',
        dialogMode: 'add',
        name: 'user input ' + (this.userInputs.length + 1).toString(),
        descriptionText: ''
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.userInputs.push({
        name: result.name,
        descriptionText: result.descriptionText,
        id: 0
      });
      this.dirty = true;
    });
  }

  editUserInput(index: number) {
    const dialogRef = this.dialog.open(UserInputDialogComponent, {
      width: '550px',
      data: {
        dialogTitle: 'Edit user input',
        dialogMode: 'edit',
        name: this.userInputs[index].name,
        descriptionText: this.userInputs[index].descriptionText,

      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.userInputs[index].name = result.name;
      this.userInputs[index].descriptionText = result.descriptionText;
      
      this.dirty = true;
    });
  }

  deleteUserInput(index: number) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: "Are you sure you want to delete this user input?"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.userInputs.splice(index, 1);
        this.dirty = true;
      }
    });
  }

  async save() {
    const ret = await this.rouseService.updateUserInputs(this.userInputs);
    if (ret === "OK")
      this.dirty = false;
  }

  discard() {
    this.initialize();
    this.dirty = false;
  }
}

